import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/generative-ai/generative_ai_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>Generative AI Solutions</h1>
              <p>
                Gen AI – a new accelerator in the transformative digital
                landscape enables process automation and optimization for
                greater outcomes with lesser efforts and setbacks. TekRevol
                excels at developing custom, responsive, and value-driven
                generative AI solutions for performance-tuned and
                optimally-maneuvered business functioning – achieve immersive
                and performant human-machine interactions.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult AI Solutions
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
